import { getCountryForTimezone } from "countries-and-timezones";

// Detects whether the visitor's machine is in India, client-side (no API), by
// resolving the browser's IANA timezone to a country (id "IN"). Used to gate
// India-only UI such as the PTE exam voucher.
export const isIndia = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return Boolean(tz && getCountryForTimezone(tz)?.id === "IN");
  } catch (e) {
    /* Intl/lookup unavailable — treat as non-India */
    return false;
  }
};

export default isIndia;
